import axios from 'axios';

function getCommonHeaders() {
  return {
    CToken: window?.highEndInfo?.ctoken || '',
    UserId: window?.highEndInfo?.uid || '',
    Version: window?.highEndInfo?.appv || '6.7.0',
    CustomerNo: window?.highEndInfo?.uid || '',
    UToken: window?.highEndInfo?.utoken || '',
    AppType: window?.highEndInfo?.app || 'ttjj',
    MobileKey: window?.highEndInfo?.deviceid || '1234567.py.service',
    ServerVersion: window?.highEndInfo?.serverversion || '6.7.0',
    BType: '1',
    PhoneType: window?.highEndInfo?.plat || '1',
  };
}
// eslint-disable-next-line import/prefer-default-export
export async function getInvestorAuditResult(param) {
  console.log('param', param);
  try {
    const zone = window?.highEndInfo?.zone || '';
    let zoneStr = zone;
    if (zone === '1') {
      zoneStr = '';
    }
    // 发送 POST 请求
    const requestData = {
      ...param,
      ...getCommonHeaders(),
    };
    const response = await axios.post(
      `https://ibgapi${zoneStr}.1234567.com.cn/senior/product/getAuditAndManuallySign`,
      requestData,
      {
        headers: getCommonHeaders(),
      },
    );
    return response?.data;
  } catch (err) {
    console.error('请求出错', err.message);
    return {};
  }
}
